import React, { useState, useEffect } from "react";
import MDButton from "components/MDButton";
import MDBox from "components/MDBox";
import Link from "@mui/material/Link";
import { enqueueSnackbar } from "notistack";
import { getAPICall } from "../../../lib/callApi";

const sizeStyles = {
  small: {
    fontSize: "12px",
    padding: "10px 16px",
  },
  medium: {
    fontSize: "14px",
    padding: "11px 20px",
  },
  large: {
    fontSize: "16px",
    padding: "12px 24px",
  },
};

const typeStyles = {
  primary: {
    color: "#000000",
    backgroundColor: "#ffffff",
    transition: "background-color .20s ease-in",
    borderRadius: ".9rem",
    padding: ".5rem 1rem",
    fontWeight: 600,
    lineHeight: "1.75rem",
    width: "100%",
    boxShadow: "none",
    border: ".5px solid black",
    "&:hover": {
      color: "#ffffff",
      backgroundColor: "#000000",
      boxShadow: "none",
    },
  },
};

const providerDefinitions = {
  jumpcloud: 1,
};

const SSOButton = ({ provider, clientId, type = "primary", size = "medium", sx = {} }) => {
  const [providerDefinition, setProviderDefinition] = useState();

  useEffect(() => {
    if (provider && clientId) {
      (async () => {
        try {
          const response = await getAPICall(`sso/calcStartUrl/${provider}/${clientId}`);
          if (response.status === 200) {
            setProviderDefinition(response.data);
          } else
            throw new Error(
              "Invalid provider or client id. Please contact your Alysio rep for more details."
            );
        } catch (err) {
          console.log("Err retrieving sso start url");
          console.log(err);
          enqueueSnackbar(
            JSON.stringify({
              icon: "error",
              title: "Error",
              text: err?.response?.data?.errMessage || err.message || "Something went wrong!",
            }),
            {
              variant: "custom",
            }
          );
        }
      })();
    }
  }, [provider, clientId]);

  if (!provider || !providerDefinitions[provider] || !clientId || !providerDefinition) return null;

  return (
    <Link href={providerDefinition.href}>
      <MDButton color={type} size={size} sx={{ ...sizeStyles[size], ...typeStyles[type], ...sx }}>
        <MDBox
          component="img"
          src={providerDefinition.logoUrl}
          alt={`${providerDefinition.label} Brand Logo`}
          width="40px"
          height="30px"
          sx={{
            marginRight: "8px",
          }}
        />
        {providerDefinition.label}
      </MDButton>
    </Link>
  );
};

export default SSOButton;
